function hasValue(value) {
    if (value === undefined || value === null) return false;
    if (typeof value === "string") return value.trim() !== "";
    return true;
}

export function omitNilFields(payload = {}) {
    return Object.keys(payload).reduce((result, key) => {
        const value = payload[key];
        if (value === undefined || value === null) {
            return result;
        }
        result[key] = value;
        return result;
    }, {});
}

export function resolveFortisPaymentMethod(data = {}) {
    const candidates = [
        data.token_id,
        data.tokenId,
        data.payment_method,
        data.paymentMethod,
        data.method_id,
        data.methodId,
        data.payment_token,
        data.paymentToken,
        data.customer_vault_id,
        data.customerVaultId,
    ];

    return candidates.find(hasValue);
}

export function getFortisEventKey(data = {}) {
    const paymentId = hasValue(data.id) ? String(data.id) : "";
    const paymentMethod = resolveFortisPaymentMethod(data);
    const normalizedMethod = hasValue(paymentMethod)
        ? String(paymentMethod)
        : "";

    return [paymentId, normalizedMethod].filter(Boolean).join(":");
}
